<template>
  <div>
    <router-link class="font-weight-bold"
                 v-if="!isPatient && object.status != 2 && !object.isOtherBranch"
                 :to="{name: 'PatientVisitPage', params: { visitid: object.id, id: object.client_id, page: 'teeth' } }">
      <div>{{ formatDate(object.start, 'DD.MM.YY, HH:mm') }} - {{ formatDate(object.end, 'HH:mm') }}</div>
      <div v-if="object.doctor">
        <a>{{ object.doctor.full_name }}</a>
      </div>
    </router-link>
    <div v-else>
      {{ formatDate(object.start, 'DD.MM.YY, HH:mm') }}
      <div v-if="object.doctor">{{ object.doctor.full_name }}</div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/extensions/filters/filters"

export default {
  name: "PatientsDatatableTDStart",
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    isPatient() {
      return this.$store.getters.isPatient
    }
  },
  methods: {
    formatDate
  }
}
</script>
